module.exports = __webpack_public_path__ + "img/start_btn.854694e0.png";